<template>
  <div id="header">
    <div class="button" @click="Open($event)">抢占5大福利</div>
  </div>
</template>

<script>
export default {
  methods: {
    Open(e) {
      this.$store.commit("Openpop", 8);
      this.$mai(2, e);
    },
  },
};
</script>

<style lang='scss' scoped>
#header {
  position: relative;
  margin-bottom: 87px;
  height: 966px;
  background-image: url("../assets/header.png");
  background-position: top center;
  background-size: cover;
  .button {
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translate(-50%);
    width: 560px;
    height: 98px;
    border-radius: 16px;
    background-image: url("../assets/btn.png");
    background-size: 100% 100%;
    text-align: center;
    font-family: SourceHanSansCN-Bold;
    font-size: 36px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 98px;
    letter-spacing: 2px;
    color: #5530fd;
  }
}
</style>